/**
 * Customer status helpers — same rules as the Customer Management Status column:
 * `status` (ACTIVE / INACTIVE) wins; legacy `isActive` is used when `status` is missing.
 */

export const INACTIVE_CUSTOMER_SELECTED_MESSAGE =
  'The selected customer is inactive. Please select an active customer.';

export const CURRENT_CUSTOMER_INACTIVE_NOTICE =
  'The current customer is inactive. Select an active customer to save changes.';

export interface CustomerStatusSource {
  status?: unknown;
  isActive?: unknown;
}

/** Customers without any status information are treated as active (backward compatible). */
export function isCustomerActive(customer: CustomerStatusSource | null | undefined): boolean {
  if (!customer) {
    return false;
  }
  const status = customer.status;
  if (status != null && String(status).trim() !== '') {
    return String(status).trim().toUpperCase() === 'ACTIVE';
  }
  if (typeof customer.isActive === 'boolean') {
    return customer.isActive;
  }
  return true;
}
